import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiLogOut } = FiIcons;

const Header = ({ user, onSignOut }) => {
  return (
    <motion.header
      initial={{ y: -50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      className="bg-primary-500 shadow-sm border-b border-primary-600"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center space-x-4">
            <img 
              src="https://letcheck.b-cdn.net/944/bild-logo-final-dunkel-1726774068395.png" 
              alt="Logo" 
              className="h-12 w-auto"
            />
            <div className="flex flex-col">
              <h1 className="text-xl font-bold text-white">
                Bildformat konvertieren
              </h1>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            {user && (
              <div className="flex items-center space-x-3">
                <span className="text-sm text-white">{user.email}</span>
                <button
                  onClick={onSignOut}
                  className="flex items-center space-x-1 text-white hover:text-gray-200 transition-colors"
                >
                  <SafeIcon icon={FiLogOut} className="text-sm" />
                  <span className="text-sm">Abmelden</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;